import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditTeamFormComponent } from './edit-team-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [EditTeamFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [EditTeamFormComponent]
})
export class EditTeamFormModule { }
